"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { getT } from "@local/i18n/src/t";
import { DEFAULT_LANGUAGE, type Language } from "@local/i18n/src/languages";
import { reviews } from "@local/i18n/src/catalogs/reviews";
import { StarRating } from "./StarRating";
import Image from "next/image";
interface Review {
  id: string;
  name: string;
  avatar?: string | null;
  rating: number;
  content: string;
  date: string;
  sourceUrl?: string;
}
interface ReviewCardProps {
  testimonial: Review;
  language?: Language;
}
const DEFAULT_AVATAR = "https://ik.imagekit.io/senja/tr:f-jpeg/Avatars/avatar_aOgsMJ-eZ.png?ik-sdk-version=javascript-1.4.3&updatedAt=1657796891741";
const TRUSTPILOT_LOGO = "https://ik.imagekit.io/senja/tr:w-40,f-png/Logos/trustpilot-logo_Hdn_TGo6b.png?updatedAt=1683237856080";
export const ReviewCard = t0 => {
  const $ = _c(26);
  const {
    testimonial,
    language: t1
  } = t0;
  const language = t1 === undefined ? DEFAULT_LANGUAGE : t1;
  const t = getT(language, {
    reviews
  });
  const [isExpanded, setIsExpanded] = useState(false);
  const shouldTruncate = testimonial.content.length > 150 && !isExpanded;
  const t2 = "h-full w-full";
  const t3 = "flex h-full flex-col rounded-lg bg-white p-4 text-left shadow-sm";
  const t4 = "flex h-full flex-col";
  const t5 = testimonial.avatar || DEFAULT_AVATAR;
  const t6 = `${testimonial.name} avatar`;
  let t7;
  if ($[0] !== t5 || $[1] !== t6) {
    t7 = <div className="flex-none"><Image src={t5} alt={t6} className="h-[42px] w-[42px] rounded-full object-cover" loading="lazy" referrerPolicy="no-referrer" width={42} height={42} quality={60} /></div>;
    $[0] = t5;
    $[1] = t6;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  let t8;
  if ($[3] !== testimonial.name) {
    t8 = <div className="min-w-0 flex-1"><div className="truncate text-sm font-medium text-gray-900">{testimonial.name}</div></div>;
    $[3] = testimonial.name;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== testimonial.sourceUrl) {
    t9 = testimonial.sourceUrl && <div className="flex-none"><a href={testimonial.sourceUrl} target="_blank" rel="nofollow noopener noreferrer"><Image src={TRUSTPILOT_LOGO} alt="trustpilot" width={20} height={20} loading="lazy" className="h-5 w-5 object-contain" /></a></div>;
    $[5] = testimonial.sourceUrl;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== t7 || $[8] !== t8 || $[9] !== t9) {
    t10 = <div className="mb-2 flex items-center gap-3">{t7}{t8}{t9}</div>;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== testimonial.rating) {
    t11 = <StarRating rating={testimonial.rating} />;
    $[11] = testimonial.rating;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const t12 = "my-2 flex-1 text-left text-sm text-gray-700";
  const t13 = shouldTruncate ? "line-clamp-4 overflow-hidden" : "";
  let t14;
  if ($[13] !== t13 || $[14] !== testimonial.content) {
    t14 = <div className={t13}>{testimonial.content}</div>;
    $[13] = t13;
    $[14] = testimonial.content;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  const t15 = testimonial.content.length > 150 && <button onClick={() => setIsExpanded(!isExpanded)} className="mt-1 cursor-pointer border-none bg-transparent text-sm text-gray-700 opacity-80 hover:opacity-100"><span>{isExpanded ? t("reviews.showLess") : t("reviews.readMore")}</span></button>;
  let t16;
  if ($[16] !== t14 || $[17] !== t15) {
    t16 = <div className={t12}>{t14}{t15}</div>;
    $[16] = t14;
    $[17] = t15;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== testimonial.date) {
    t17 = <div className="mt-auto pt-2 text-xs text-gray-500">{testimonial.date}</div>;
    $[19] = testimonial.date;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t16 || $[24] !== t17) {
    t18 = <div className={t2}><div className={t3}><div className={t4}>{t10}{t11}{t16}{t17}</div></div></div>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t16;
    $[24] = t17;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  return t18;
};